import { render, staticRenderFns } from "./smsTemplate.vue?vue&type=template&id=cbac93ba&scoped=true"
import script from "./smsTemplate.vue?vue&type=script&lang=js"
export * from "./smsTemplate.vue?vue&type=script&lang=js"
import style0 from "./smsTemplate.vue?vue&type=style&index=0&id=cbac93ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbac93ba",
  null
  
)

export default component.exports